/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param  h   Number    The hue
 * @param  s   Number    The saturation
 * @param  l   Number    The lightness
 * @return     Array     The RGB representation
 */
function hslToRgb (h, s, l) {
  let r, g, b;

  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;

    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return [r * 255, g * 255, b * 255];
}

function componentToHex (c) {
  const hex = Math.floor(c).toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

function rgbToHex (r, g, b) {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

export function getNcolorsBasti (n) {
  const vs = [];
  const phi = 1.61803398875; // (1 + sqrt(2)) / 2
  let c = 0;
  for (let i = 0; i < n; i++) {
    vs.push(c);
    c += phi;
    c %= 1.0;
  }
  return vs.map(col => rgbToHex(...hslToRgb(col, 1, 1)));
}

export const katys100colors = [
  '#C1121F', '#606C38', '#FFB703', '#FB8500', '#219EBC', '#023E7D', '#344E41',
  '#F15BB5', '#00BBF9', '#9B5DE5', '#2A9D8F', '#A7C957', '#432818', '#FFA5C8',
  '#023E7D', '#80B918', '#CB904D', '#FF4701', '#0AFF99', '#FF0AAD', '#FFBC0A',
  '#021541', '#986F2F', '#086788', '#A8C256', '#DA3E52', '#824C71', '#FC8599',
  '#003F87', '#FC8599', '#4A6BDC', '#6EC4CC', '#FF1B1C', '#051899', '#FF7096',
  '#DA1E37', '#FFA98F', '#FBBF45', '#33BBFF', '#7B76D0', '#B02E90', '#008148',
  '#D7E97E', '#FF0A54', '#583101', '#8A2846', '#3F37C9', '#03045E', '#2D6A4F',
  '#FF0000', '#0000FF', '#445D48', '#5E3023', '#23967F', '#46B3B4', '#E0E300',
  '#00773A', '#EE6900', '#B68036', '#5FA8D3', '#FF9900', '#0A85ED', '#17FFC4',
  '#7B2CBF', '#E2AFFF', '#EC4C94', '#A4807E', '#0A9396', '#398000', '#FE7C49',
  '#7B0078', '#718355', '#2E5354', '#97BA7B', '#EA3669', '#06D6A0', '#0077B6',
  '#E280A0', '#52D997', '#22DCDC', '#D8D972', '#FFA399', '#6BCDA1', '#BC7Cd4',
  '#CF6293', '#566E6D', '#73AAB0', '#023E8A', '#ED8354', '#9D61B2', '#E55E9A',
  '#CC6B63', '#A655B9', '#75C236', '#F87946', '#C478C2', '#2FC7AD', '#495057',
  '#78985F', '#DD577C'];

export function getNcolorsKaty (n) {
  const colors = [];
  for (let i = 0; i < n; i++) {
    colors.push(getNcolorsKaty[i % 100]);
  }
  return colors;
}
